/* Barra de MARCAS de la home: los logos de los fabricantes que trabaja Allure, desfilando
 * despacio hacia la izquierda.
 *
 * Criterio (JP 2026-08-05): va SIEMPRE entre la pestaña de la patente y el titulo "Busca el
 * repuesto para tu auto" — es la prueba de respaldo justo antes de que el cliente elija su marca.
 * Logos en miniatura y movimiento MUY lento: tiene que leerse como un detalle, no como un banner.
 *
 * Asset aparte para no tocar allure-tecdoc.js, mismo criterio que allure-frenos-home.js: la home
 * la pinta el SPA (y la repinta al cambiar de vista), asi que aca solo se observa e inserta.
 *
 * Los logos y sus URLs los inyecta allure-tecdoc.liquid en #al-marcas-json (asset_url de Shopify).
 * Para sumar o sacar una marca se edita esa lista en el liquid; este archivo no cambia.
 */
(function () {
  var app = document.getElementById('allure-app');
  if (!app) return;
  if (app.dataset.marcasOn === 'false') return;

  var MARCAS = [];
  try {
    var json = document.getElementById('al-marcas-json');
    MARCAS = json ? JSON.parse(json.textContent) : [];
  } catch (e) { MARCAS = []; }
  if (!MARCAS.length) return;

  var SEG = parseInt(app.dataset.marcasSeg, 10) || 160;   // segundos por vuelta completa
  var TITULO = app.dataset.marcasTitulo || '';

  var CSS = '' +
    '.almq{position:relative;margin:2px 0 4px;padding:13px 0;background:#fff;' +
      'border-top:1px solid var(--linea-2,#eef0f3);border-bottom:1px solid var(--linea-2,#eef0f3)}' +
    '.almq-tit{margin:0 0 10px;text-align:center;font-size:10.5px;font-weight:700;' +
      'letter-spacing:.1em;text-transform:uppercase;color:var(--txt-3,#9aa1ac)}' +
    /* el degradado de los bordes es lo que hace que los logos "entren y salgan" sin cortarse */
    '.almq-vp{overflow:hidden;' +
      '-webkit-mask-image:linear-gradient(90deg,transparent,#000 7%,#000 93%,transparent);' +
      'mask-image:linear-gradient(90deg,transparent,#000 7%,#000 93%,transparent)}' +
    /* la pista lleva la lista DUPLICADA: al correr -50% queda igual que al empezar y el loop no salta */
    '.almq-track{display:flex;align-items:center;width:max-content;' +
      'animation:almq-run var(--almq-seg,160s) linear infinite}' +
    '.almq:hover .almq-track{animation-play-state:paused}' +
    '@keyframes almq-run{from{transform:translateX(0)}to{transform:translateX(-50%)}}' +
    /* padding por item (NO gap): asi las dos mitades miden exactamente lo mismo y el -50% es exacto */
    '.almq-i{flex:0 0 auto;height:34px;padding:0 15px;display:flex;align-items:center;justify-content:center}' +
    '.almq-i img{width:auto;height:auto;max-width:86px;max-height:29px;object-fit:contain;display:block}' +
    /* alto por forma del logo (lo mide el JS): los cuadrados necesitan mas alto para pesar igual */
    '.almq-i.is-sq img{max-height:34px;max-width:78px}' +
    '.almq-i.is-mid img{max-height:31px;max-width:90px}' +
    '.almq-i.is-wide img{max-height:26px;max-width:100px}' +
    '@media(max-width:600px){' +
      '.almq{padding:9px 0}' +
      '.almq-i{height:28px;padding:0 11px}' +
      '.almq-i img{max-width:70px;max-height:24px}' +
      '.almq-i.is-sq img{max-height:28px;max-width:64px}' +
      '.almq-i.is-mid img{max-height:26px;max-width:74px}' +
      '.almq-i.is-wide img{max-height:22px;max-width:82px}}' +
    /* quien pidio menos movimiento ve la franja quieta y la puede correr a mano */
    '@media(prefers-reduced-motion:reduce){' +
      '.almq-track{animation:none}' +
      '.almq-vp{overflow-x:auto;-webkit-overflow-scrolling:touch}}';

  var styleOk = false;
  function css() {
    if (styleOk) return;
    var st = document.createElement('style'); st.textContent = CSS;
    document.head.appendChild(st); styleOk = true;
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }

  // Una copia completa de la lista. oculta = la duplicada, que el lector de pantalla debe ignorar.
  function copia(oculta) {
    return MARCAS.map(function (m) {
      return '<div class="almq-i"' + (oculta ? ' aria-hidden="true"' : '') + '>' +
        '<img src="' + esc(m.u) + '" alt="' + (oculta ? '' : esc(m.n)) + '" decoding="async">' +
      '</div>';
    }).join('');
  }

  function barra() {
    var d = document.createElement('div');
    d.className = 'almq';
    d.style.setProperty('--almq-seg', SEG + 's');
    d.innerHTML =
      (TITULO ? '<p class="almq-tit">' + esc(TITULO) + '</p>' : '') +
      '<div class="almq-vp"><div class="almq-track">' + copia(false) + copia(true) + '</div></div>';

    // El alto de cada logo sale de su proporcion real: asi un logo nuevo se acomoda solo.
    Array.prototype.forEach.call(d.querySelectorAll('img'), function (img) {
      function forma() {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) return;
        var r = w / h;
        img.parentNode.classList.add(r >= 2.6 ? 'is-wide' : (r >= 1.5 ? 'is-mid' : 'is-sq'));
      }
      // Si falla la descarga se esconde el item — y como falla en las dos copias, el loop sigue calzando.
      img.addEventListener('error', function () { img.parentNode.style.display = 'none'; });
      if (img.complete) forma(); else img.addEventListener('load', forma);
    });
    return d;
  }

  function insertar() {
    if (app.querySelector('.almq')) return;
    var h = (location.hash || '#home').slice(1).split('/')[0];
    if (h && h !== 'home') return;
    var hero = app.querySelector('.al-hero');   // el titulo "Busca el repuesto para tu auto"
    if (!hero) return;
    css();
    hero.parentNode.insertBefore(barra(), hero);
  }

  // allure-tecdoc.js pinta async y repinta al cambiar de vista: se observa en vez de esperar.
  new MutationObserver(insertar).observe(app, { childList: true, subtree: true });
  insertar();
})();
